import { LookupModelSearchEvent } from '@mcleod/components/src/events/LookupModelSearchEvent';
import { AutogenLayoutSalesActivityReport } from './autogen/AutogenLayoutSalesActivityReport';

/**
 * Sales Activity Report - Web Implementation
 * PBI: 352177
 *
 * Displays sales activity details by various criteria to track
 * sales team performance and customer/prospect interactions.
 */
export class SalesActivityReport extends AutogenLayoutSalesActivityReport {

    onLoad(): void {
        // Set default values by selecting the first item in each dropdown
        this.textboxActivityType.selectedItem = this.textboxActivityType.items[0];
        this.textboxGroupBy.selectedItem = this.textboxGroupBy.items[0];
        this.textboxSortBy.selectedItem = this.textboxSortBy.items[0];
        this.textboxProspectType.selectedItem = this.textboxProspectType.items[0];
    }

    excludabletextboxOperationsUserBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        // Filter to only show User ('U') or Employee ('E') web user types
        event.filter.web_user_type = "U || E";
    }

    excludabletextboxActivityBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.type_of = "C";
    }

    textboxGroupByAfterDropdownSelection() {
        if (this.textboxGroupBy.text === "None") {
            this.checkboxPageBreak.enabled = false;
            this.checkboxPageBreak.checked = false;
        } else {
            this.checkboxPageBreak.enabled = true;
        }
    }

     /**
     * Update the customer lookup model based on the selected customer/prospect type
     */
    textboxProspectTypeOnChange(): void {
        const typeValue = this.textboxProspectType.selectedItem?.value;

        // Get the textbox component from the excludable textbox
        const customerTextbox = this.excludabletextboxCustomers.textbox;

        if (!customerTextbox) {
            return;
        }

        customerTextbox.clear();
        // Update lookup model based on selection
        // A = Both (PROSP_CUST), B = Prospects Only (PROSPECT), C = Customers Only (CUST_ALL)
        switch (typeValue) {
            default:
            case "A": // Both
                customerTextbox.caption = "Customer(s) / Prospect(s)";
                break;
            case "B": // Prospects Only
                customerTextbox.caption = "Prospect(s)";
                break;
            case "C": // Customers Only
                customerTextbox.caption = "Customer(s)";
                break;
        }
    }

        textboxCustomersBeforeLookupModelSearch(event) {
        const customersOrProspects = this.textboxProspectType.selectedItem?.value;
        switch (customersOrProspects) {
            default:
            case "A": // Both
                // No filtering
                break;
            case "B": // Prospects Only
                event.filter.type_of = "P"; // Filter to prospects only
                break;
            case "C": // Customers Only
                event.filter.type_of = "C"; // Filter to customers only
        }
    }


}
